import type { ScheduleSummary } from '@/lib/api';

/**
 * Whose paused schedule is whose (docs/JOB-LIFECYCLE.md 2.7).
 *
 * A schedule the hub stopped after two bad runs is waiting on the person whose
 * approval it carries, and on nobody else: every verb on it is theirs or an
 * admin's, and the hub answers a stranger with a sentence. So "Waiting on you"
 * and the accent the rail gives it are scoped the same way the buttons are,
 * rather than showing every member a gate they cannot pass.
 *
 * The same tolerant-enough comparison `BriefDetail` and `TaskDetail` use for
 * "did I file this": exact on the trimmed, lower-cased name. It errs towards
 * showing a person less rather than more, which for a prompt is the right
 * direction, and the schedule is still on the page either way.
 */
export function approvedByViewer(schedule: ScheduleSummary, actor: string): boolean {
  return schedule.approvedBy.trim().toLowerCase() === actor.trim().toLowerCase();
}

/** The paused schedules this person is the one to do something about. */
export function pausedForViewer(
  schedules: readonly ScheduleSummary[],
  actor: string,
  isAdmin: boolean,
): ScheduleSummary[] {
  return schedules.filter(
    (schedule) => schedule.pausedAt && (isAdmin || approvedByViewer(schedule, actor)),
  );
}
